import { useState } from "react";
import { OtbSelect } from "../otb.planning.shared";

export function NovoOtbModal({ actions, ctx }) {
  const {
    closeNovoOtbModal,
    updateNovoOtbForm,
    criarOtb,
  } = actions || {};

  const {
    canais,
    periodos,
    departamentos,
    novoOtbCategorias,
    novoOtbForm,
  } = ctx || {};

  const {
    nome,
    canal,
    periodo,
    departamentos: selDepts = [],
    categorias: selCats = [],
  } = novoOtbForm || {};

  const [nomeInputFocused, setNomeInputFocused] = useState(false);

  const toggleSelection = (field, selectedItems = [], value) => {
    updateNovoOtbForm(
      field,
      selectedItems.includes(value)
        ? selectedItems.filter((item) => item !== value)
        : [...selectedItems, value]
    );
  };

  const todasSelecionadas =
    novoOtbCategorias?.every((c) => selCats.includes(c)) ?? false;

  const toggleSelecionarTodas = () => {
    updateNovoOtbForm(
      "categorias",
      todasSelecionadas ? [] : novoOtbCategorias
    );
  };

  return (
    <>
      <div
        onClick={closeNovoOtbModal}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 1000,
        }}
      />

      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1001,
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
          width: 520,
          maxHeight: "85vh",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            padding: "24px 28px 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <span
            style={{
              fontSize: "17px",
              fontWeight: "700",
              color: "#1a1a1a",
            }}
          >
            Criar Novo OTB
          </span>

          <button
            onClick={closeNovoOtbModal}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              color: "#aaa",
              cursor: "pointer",
              lineHeight: 1,
              padding: 4,
            }}
          >
            ×
          </button>
        </div>

        <div
          style={{
            padding: "20px 28px 28px",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <div>
            <label
              style={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#333",
                display: "block",
                marginBottom: 6,
              }}
            >
              Nome do OTB
            </label>

            <input
              value={nome}
              onChange={(e) =>
                updateNovoOtbForm("nome", e.target.value)
              }
              onFocus={() => setNomeInputFocused(true)}
              onBlur={() => setNomeInputFocused(false)}
              placeholder="Ex: OTB Feminino E-commerce"
              style={{
                width: "100%",
                padding: "9px 12px",
                border: `1.5px solid ${
                  nomeInputFocused ? "#e8773a" : "#ddd"
                }`,
                borderRadius: "8px",
                fontSize: "13px",
                outline: "none",
                color: "#333",
                boxSizing: "border-box",
                transition: "border-color 0.15s",
              }}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 16,
            }}
          >
            <div>
              <label
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#333",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                Canal
              </label>

              <OtbSelect
                value={canal}
                onChange={(v) =>
                  updateNovoOtbForm("canal", v)
                }
                options={canais || []}
                minWidth="100%"
              />
            </div>

            <div>
              <label
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#333",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                Período
              </label>

              <OtbSelect
                value={periodo}
                onChange={(v) =>
                  updateNovoOtbForm("periodo", v)
                }
                options={periodos || []}
                minWidth="100%"
              />
            </div>
          </div>

          {/* Departamentos */}
          <div>
            <label
              style={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#333",
                display: "block",
                marginBottom: 10,
              }}
            >
              Departamentos
            </label>

            <div
              style={{
                display: "flex",
                gap: 12,
                flexWrap: "wrap",
              }}
            >
              {departamentos?.map((d) => {
                const checked = selDepts.includes(d);

                return (
                  <button
                    key={d}
                    onClick={() =>
                      toggleSelection(
                        "departamentos",
                        selDepts,
                        d
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "7px 14px",
                      border: `1.5px solid ${
                        checked ? "#e8773a" : "#e0e0e0"
                      }`,
                      borderRadius: "8px",
                      background: "none",
                      cursor: "pointer",
                      fontSize: "13px",
                      color: "#333",
                      transition: "border-color 0.15s",
                    }}
                  >
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        border: "2px solid #e8773a",
                        background: checked
                          ? "#e8773a"
                          : "#fff",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {checked && (
                        <span
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }}
                        />
                      )}
                    </span>

                    {d}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Categorias */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#333",
                  margin: 0,
                }}
              >
                Categorias
              </p>

              <button
                onClick={toggleSelecionarTodas}
                style={{
                  fontSize: "12px",
                  color: "#e8773a",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {todasSelecionadas
                  ? "Desmarcar todas"
                  : "Selecionar todas"}
              </button>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px 16px",
                maxHeight: 220,
                overflowY: "auto",
                paddingRight: 4,
              }}
            >
              {novoOtbCategorias?.map((c) => {
                const checked = selCats.includes(c);

                return (
                  <button
                    key={c}
                    onClick={() =>
                      toggleSelection(
                        "categorias",
                        selCats,
                        c
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "6px 8px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "13px",
                      color: "#333",
                      textAlign: "left",
                    }}
                  >
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        border: "2px solid #e8773a",
                        background: checked
                          ? "#e8773a"
                          : "#fff",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      {checked && (
                        <span
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }}
                        />
                      )}
                    </span>

                    {c}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Ações */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              paddingTop: 4,
            }}
          >
            <button
              onClick={closeNovoOtbModal}
              style={{
                padding: "9px 24px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                background: "#fff",
                cursor: "pointer",
                fontSize: "13px",
                color: "#555",
              }}
            >
              Cancelar
            </button>

            <button
              onClick={criarOtb}
              disabled={!nome?.trim()}
              style={{
                padding: "9px 24px",
                border: "none",
                borderRadius: "8px",
                background: nome?.trim()
                  ? "#e8773a"
                  : "#e0a07e",
                cursor: nome?.trim()
                  ? "pointer"
                  : "not-allowed",
                fontSize: "13px",
                color: "#fff",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: 6,
                opacity: nome?.trim() ? 1 : 0.7,
              }}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>

              Criar OTB
            </button>
          </div>
        </div>
      </div>
    </>
  );
}          